import React, { useState } from 'react';
// Force TS reload
import { AddOnDto, IAddOn } from '@eagerdog/interfaces';
import { Constants } from '@eagerdog/constants';
import Button from 'src/components/Button/Button';
import Input from 'src/components/Input/Input';
import { apiService } from 'src/services/api.service';
import { toast } from 'src/components/Toast/ToastManager';
import styles from './EditAddon.module.scss';

interface EditAddonProps {
  addon: IAddOn;
  eventId: string;
  onFinish: () => void;
  onCancel: () => void;
}

const EditAddon: React.FC<EditAddonProps> = ({
                                               addon,
                                               eventId,
                                               onFinish,
                                               onCancel
}) => {
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState(addon?.title || '');
  const [description, setDescription] = useState(addon?.description || '');
  const [fee, setFee] = useState(addon?.fee || '');
  const [quantity, setQuantity] = useState(addon?.available_quantity || '');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      const updateData: AddOnDto = {
        scope: Constants.add_on_scope.event,
        title,
        description,
        fee: Number(fee),
        available_quantity: Number(quantity)
      };

      await apiService.updateEventAddOn(eventId, addon._id, updateData);
      
      toast.show({
        title: 'Success',
        content: 'Add-On updated successfully',
        type: 'success',
        duration: 5000
      });
      
      onFinish();
    } catch (error: any) {
      console.error('Error updating add-on:', error);
      toast.show({
        title: 'Error',
        content: error.response?.data?.message || 'Failed to update add-on',
        type: 'fail',
        duration: 5000
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className={styles.editAddonModal} onSubmit={handleSubmit}>
      <div className={styles.title}>Edit Add-On</div>
      <div className={styles.modalInner}>
        <div className={styles.formField}>
          <Input
            label="Add-On Title"
            placeholder="Enter add-on title"
            name="title"
            required={true}
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>
        <div className={styles.formField}>
          <Input
            label="Add-On Description"
            placeholder="Enter add-on description"
            name="description"
            required={true}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>
        <div className={styles.formField}>
          <Input
            label="Price"
            placeholder="How much does it cost?"
            name="price"
            type="number"
            required={true}
            value={fee}
            onChange={(e) => setFee(e.target.value)}
          />
        </div>
        <div className={styles.formField}>
          <Input
            label="Quantity"
            placeholder="How many available?"
            name="quantity"
            type="number"
            required={true}
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
          />
        </div>
      </div>

      <div className={styles.modalActions}>
        <Button 
          type="button" 
          onClick={onCancel}
          disabled={loading}
        >
          Cancel
        </Button>
        <Button 
          type="submit" 
          disabled={loading}
        >
          {loading ? 'Updating...' : 'Update Add-On'}
        </Button>
      </div>
    </form>
  );
};

export default EditAddon;